import { render, staticRenderFns } from "./generic-button.vue?vue&type=template&id=4d4efcb2&lang=html&"
import script from "./generic-button.vue?vue&type=script&lang=js&"
export * from "./generic-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports